export default __webpack_public_path__ + "media/images/front/about/meetup-be5eab0fa151b3c6dba60e768697115d.jpg";